

export const artistRegEx = new RegExp('^(https://open.spotify.com/artist/)') 

export const clientId = 'e2095081dfcd41fdb31fe8d719120e7d'

export default clientId